import { JWT } from '@/models/User';

export function setCookie(cookieName: string, cookieValue: string, expirationDays: number) {
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);

  const newCookieValue =
    cookieName === 'gdpr_analytics' ? cookieValue : encodeURIComponent(cookieValue);
  const domain = ['localhost', '.gh-platform.cloud'].some((host) =>
    window.location.hostname.endsWith(host),
  )
    ? window.location.hostname
    : '.goodhabitz.com';

  document.cookie = `${cookieName}=${newCookieValue}; expires=${expiryDate}; path=/; domain=${domain}; SameSite=None; secure`;
}

export function getCookie(name: string) {
  const cookieName = name + '=';
  const cookieArray = document.cookie.split(';');

  for (const cookie of cookieArray) {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.startsWith(cookieName)) {
      const cookieValue = trimmedCookie.split('=')[1];

      if (name === 'gdpr_analytics') {
        return cookieValue;
      } else {
        return decodeURIComponent(cookieValue);
      }
    }
  }

  return '';
}

export function isAnalyticsEnabled() {
  const gdprAnalyticsCookie = getCookie('gdpr_analytics');
  if (gdprAnalyticsCookie) {
    try {
      const { AC } = JSON.parse(gdprAnalyticsCookie) || { AC: 0 };
      return AC === 1;
    } catch (error) {
      return false;
    }
  }
  return false;
}

export function isActivityRatingHidden() {
  const activityRatingCookie = getCookie('activity_rating');

  return activityRatingCookie === 'hidden';
}

export const removeFromStorage = (storage: Storage, keys: string[]) => {
  keys.forEach((key) => storage.removeItem(key));
};

export const getToken = (): string | null => {
  return sessionStorage.getItem('token') ?? localStorage.getItem('token') ?? null;
};

export const handleSavedToken = () => {
  const savedToken = window.localStorage.getItem('ghtoken');
  if (savedToken) {
    window.localStorage.setItem('token', savedToken);
    removeFromStorage(window.localStorage, ['ghtoken']);
  }
};

export const clearContentRelatedStorage = () =>
  removeFromStorage(window.sessionStorage, [
    'contentType',
    'platform',
    'contentMode',
    'activityMode',
    'contentId',
    'lmsSessionId',
    'lastContextId',
    'lastActivityId',
  ]);

export const clearUserRelatedStorage = () => {
  removeFromStorage(window.localStorage, ['single-page-access', 'token', 'websession']);
  handleSavedToken();
};

export const parseJwt = (token: string): JWT | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};
